// extracted by mini-css-extract-plugin
module.exports = {"container":"buttons-form-arrow-container"};